import { ICombination } from '../../AssignResults/Context/AssignResults.context';

export const isTeamStrokeplay = ({
  format: {
    format: { prefix }
  }
}: ICombination) => prefix === 'teamstroke';
